import { createSelector, createSlice } from "@reduxjs/toolkit";

const data = [
	{
		id: "Clinical Equipment - Anesthesia Equipment",
		major: "Clinical Equipment",
		minor: "Anesthesia Equipment",
		category: "CLINEQ-ANAESTH",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 10,
		prorate: "FSTMONTH",
	},
	{
		id: "Cultural Assets - Art - Non Depreciating",
		major: "Cultural Assets",
		minor: "Art - Non Depreciating",
		category: "CULTURAL-ART",
		assetAccount: 9167,
		wipAccount: null,
		expenseAccount: 5967,
		depreciation: "SL",
		lifeYears: 0,
		prorate: "FSTMONTH",
	},
	{
		id: "Clinical Equipment - Biomed Equipment",
		major: "Clinical Equipment",
		minor: "Biomed Equipment",
		category: "CLINEQ-BIOMEDEQ",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 10,
		prorate: "FSTMONTH",
	},
	{
		id: "Buildings - Building Fitout",
		major: "Buildings",
		minor: "Building Fitout",
		category: "BLDG-BLDGFITOUT",
		assetAccount: 9132,
		wipAccount: 9332,
		expenseAccount: 5932,
		depreciation: "STL",
		lifeYears: 20,
		prorate: "FSTMONTH",
	},
	{
		id: "Buildings - Building Services",
		major: "Buildings",
		minor: "Building Services",
		category: "BLDG-SERVICES",
		assetAccount: 9132,
		wipAccount: 9332,
		expenseAccount: 5932,
		depreciation: "STL",
		lifeYears: 35,
		prorate: "FSTMONTH",
	},
	{
		id: "Buildings - Building Structure",
		major: "Buildings",
		minor: "Building Structure",
		category: "BLDG-STRUCTURE",
		assetAccount: 9132,
		wipAccount: 9332,
		expenseAccount: 5932,
		depreciation: "STL",
		lifeYears: 50,
		prorate: "FSTMONTH",
	},
	{
		id: "Motor Vehicles - Cars",
		major: "Motor Vehicles",
		minor: "Cars",
		category: "MOTOR-CARS",
		assetAccount: 9139,
		wipAccount: 9339,
		expenseAccount: 5939,
		depreciation: "STL",
		lifeYears: 5,
		prorate: "FSTMONTH",
	},
	{
		id: "Clinical Equipment - Defibrillators",
		major: "Clinical Equipment",
		minor: "Defibrillators",
		category: "CLINEQ-DEFIBS",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 7,
		prorate: "FSTMONTH",
	},
	{
		id: "Clinical Equipment - Dental Equipment",
		major: "Clinical Equipment",
		minor: "Dental Equipment",
		category: "CLINEQ-DENTALEQ",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 10,
		prorate: "FSTMONTH",
	},
	{
		id: "Clinical Equipment - Dialysis Equipment",
		major: "Clinical Equipment",
		minor: "Dialysis Equipment",
		category: "CLINEQ-DIALYSEQ",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 8,
		prorate: "FSTMONTH",
	},
	{
		id: "Clinical Equipment - ENT Equipment",
		major: "Clinical Equipment",
		minor: "ENT Equipment",
		category: "CLINEQ-ENTEQ",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 8,
		prorate: "FSTMONTH",
	},
	{
		id: "Clinical Equipment - Examination Lights",
		major: "Clinical Equipment",
		minor: "Examination Lights",
		category: "CLINEQ-LIGHTS",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 8,
		prorate: "FSTMONTH",
	},
	{
		id: "General Equipment - General Furniture",
		major: "General Equipment",
		minor: "General Furniture",
		category: "GENEQ-FURNISH",
		assetAccount: 9167,
		wipAccount: 9367,
		expenseAccount: 5967,
		depreciation: "STL",
		lifeYears: 10,
		prorate: "FSTMONTH",
	},
	{
		id: "Cultural Assets - Heritage Assets",
		major: "Cultural Assets",
		minor: "Heritage Assets",
		category: "CULTURAL-HERITAGE",
		assetAccount: 9167,
		wipAccount: null,
		expenseAccount: 5967,
		depreciation: "SL",
		lifeYears: 0,
		prorate: "FSTMONTH",
	},
	{
		id: "Clinical Equipment - Incubator",
		major: "Clinical Equipment",
		minor: "Incubator",
		category: "CLINEQ-INCUBAT",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 10,
		prorate: "FSTMONTH",
	},
	{
		id: "General Equipment - Kitchen Equipment",
		major: "General Equipment",
		minor: "Kitchen Equipment",
		category: "GENEQ-KITCHENEQ",
		assetAccount: 9167,
		wipAccount: 9367,
		expenseAccount: 5967,
		depreciation: "STL",
		lifeYears: 7,
		prorate: "FSTMONTH",
	},
	{
		id: "Clinical Equipment - Laboratory Equipment",
		major: "Clinical Equipment",
		minor: "Laboratory Equipment",
		category: "CLINEQ-LABEQUIP",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 8,
		prorate: "FSTMONTH",
	},
	{
		id: "Land - Land",
		major: "Land",
		minor: "Land",
		category: "LAND-LAND",
		assetAccount: 9122,
		wipAccount: 9332,
		expenseAccount: 5903,
		depreciation: "SL",
		lifeYears: 0,
		prorate: "FSTMONTH",
	},
	{
		id: "Lease Land and Buildings - Leased Buildings",
		major: "Lease Land and Buildings",
		minor: "Leased Buildings",
		category: "LEASE-LBUILD",
		assetAccount: 9138,
		wipAccount: 9338,
		expenseAccount: 5938,
		depreciation: "STL",
		lifeYears: null,
		prorate: "FSTMONTH",
	},
	{
		id: "Lease Land and Buildings - Leased Land",
		major: "Lease Land and Buildings",
		minor: "Leased Land",
		category: "LEASE-LLAND",
		assetAccount: 9138,
		wipAccount: 9338,
		expenseAccount: 5938,
		depreciation: "SL",
		lifeYears: 0,
		prorate: "FSTMONTH",
	},
	{
		id: "Lease Land and Buildings - Leasehold Improvements",
		major: "Lease Land and Buildings",
		minor: "Leasehold Improvements",
		category: "LEASE-LHIMPROV",
		assetAccount: 9138,
		wipAccount: 9338,
		expenseAccount: 5938,
		depreciation: "STL",
		lifeYears: 5,
		prorate: "FSTMONTH",
	},
	{
		id: "Clinical Equipment - Linear Accelerators",
		major: "Clinical Equipment",
		minor: "Linear Accelerators",
		category: "CLINEQ-LINACS",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 12,
		prorate: "FSTMONTH",
	},
	{
		id: "Clinical Equipment - Manual and Electric Beds",
		major: "Clinical Equipment",
		minor: "Manual and Electric Beds",
		category: "CLINEQ-BEDS",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 15,
		prorate: "FSTMONTH",
	},
	{
		id: "Clinical Equipment - Medical Cart",
		major: "Clinical Equipment",
		minor: "Medical Cart",
		category: "CLINEQ-CARTS",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 15,
		prorate: "FSTMONTH",
	},
	{
		id: "Clinical Equipment - Medical Fridge/Freezer",
		major: "Clinical Equipment",
		minor: "Medical Fridge/Freezer",
		category: "CLINEQ-FREEZERS",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 12,
		prorate: "FSTMONTH",
	},
	{
		id: "Clinical Equipment - Medical Pumps",
		major: "Clinical Equipment",
		minor: "Medical Pumps",
		category: "CLINEQ-PUMPS",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 5,
		prorate: "FSTMONTH",
	},
	{
		id: "Clinical Equipment - Microscope",
		major: "Clinical Equipment",
		minor: "Microscope",
		category: "CLINEQ-MICROSCOPE",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 12,
		prorate: "FSTMONTH",
	},
	{
		id: "Motor Vehicles - Mobile Unit Incl Dental",
		major: "Motor Vehicles",
		minor: "Mobile Unit Incl Dental",
		category: "MOTOR-MOBILE",
		assetAccount: 9139,
		wipAccount: 9339,
		expenseAccount: 5939,
		depreciation: "STL",
		lifeYears: 10,
		prorate: "FSTMONTH",
	},
	{
		id: "ITC Equipment - Multifunctional Devices",
		major: "ITC Equipment",
		minor: "Multifunctional Devices",
		category: "ITCEQ-MFDS",
		assetAccount: 9179,
		wipAccount: 9379,
		expenseAccount: 5979,
		depreciation: "STL",
		lifeYears: 5,
		prorate: "FSTMONTH",
	},
	{
		id: "ITC Equipment - Network Equipment and Servers",
		major: "ITC Equipment",
		minor: "Network Equipment and Servers",
		category: "ITCEQ-NETWORK",
		assetAccount: 9179,
		wipAccount: 9379,
		expenseAccount: 5979,
		depreciation: "STL",
		lifeYears: 5,
		prorate: "FSTMONTH",
	},
	{
		id: "General Equipment - Office Equipment",
		major: "General Equipment",
		minor: "Office Equipment",
		category: "GENEQ-OFFICEEQ",
		assetAccount: 9167,
		wipAccount: 9367,
		expenseAccount: 5967,
		depreciation: "STL",
		lifeYears: 10,
		prorate: "FSTMONTH",
	},
	{
		id: "Clinical Equipment - Ophthalmic Equipment",
		major: "Clinical Equipment",
		minor: "Ophthalmic Equipment",
		category: "CLINEQ-OPHTHALEQ",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 10,
		prorate: "FSTMONTH",
	},
	{
		id: "Cultural Assets - Other Cultural Assets",
		major: "Cultural Assets",
		minor: "Other Cultural Assets",
		category: "CULTURAL-OTHRCULT",
		assetAccount: 9167,
		wipAccount: null,
		expenseAccount: 5967,
		depreciation: "SL",
		lifeYears: 0,
		prorate: "FSTMONTH",
	},
	{
		id: "General Equipment - Other Equipment",
		major: "General Equipment",
		minor: "Other Equipment",
		category: "GENEQ-OTHGENEQ",
		assetAccount: 9167,
		wipAccount: 9367,
		expenseAccount: 5967,
		depreciation: "STL",
		lifeYears: 10,
		prorate: "FSTMONTH",
	},
	{
		id: "ITC Equipment - Other ITC Equipment",
		major: "ITC Equipment",
		minor: "Other ITC Equipment",
		category: "ITCEQ-ITCOTHEQ",
		assetAccount: 9179,
		wipAccount: 9379,
		expenseAccount: 5979,
		depreciation: "STL",
		lifeYears: 5,
		prorate: "FSTMONTH",
	},
	{
		id: "Clinical Equipment - Other Medical Equipment",
		major: "Clinical Equipment",
		minor: "Other Medical Equipment",
		category: "CLINEQ-MEDEQUIP",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 8,
		prorate: "FSTMONTH",
	},
	{
		id: "Motor Vehicles - Other Vehicles Incl Trailers",
		major: "Motor Vehicles",
		minor: "Other Vehicles Incl Trailers",
		category: "MOTOR-MVOTHS",
		assetAccount: 9139,
		wipAccount: 9339,
		expenseAccount: 5939,
		depreciation: "STL",
		lifeYears: 10,
		prorate: "FSTMONTH",
	},
	{
		id: "Clinical Equipment - Patient Hoist",
		major: "Clinical Equipment",
		minor: "Patient Hoist",
		category: "CLINEQ-HOISTS",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 10,
		prorate: "FSTMONTH",
	},
	{
		id: "Clinical Equipment - Patient Monitoring Equipment Incl ECG and EKG",
		major: "Clinical Equipment",
		minor: "Patient Monitoring Equipment Incl ECG and EKG",
		category: "CLINEQ-MONITORS",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 7,
		prorate: "FSTMONTH",
	},
	{
		id: "ITC Equipment - PCs and Laptops",
		major: "ITC Equipment",
		minor: "PCs and Laptops",
		category: "ITCEQ-PCS",
		assetAccount: 9179,
		wipAccount: 9379,
		expenseAccount: 5979,
		depreciation: "STL",
		lifeYears: 5,
		prorate: "FSTMONTH",
	},
	{
		id: "General Equipment - Plant - not subject to Revaluation",
		major: "General Equipment",
		minor: "Plant - not subject to Revaluation",
		category: "GENEQ-GENPLANT",
		assetAccount: 9167,
		wipAccount: 9367,
		expenseAccount: 5967,
		depreciation: "STL",
		lifeYears: 25,
		prorate: "FSTMONTH",
	},
	{
		id: "Buildings - Residential Buildings",
		major: "Buildings",
		minor: "Residential Buildings",
		category: "BLDG-RESIDENT",
		assetAccount: 9132,
		wipAccount: 9332,
		expenseAccount: 5932,
		depreciation: "STL",
		lifeYears: 50,
		prorate: "FSTMONTH",
	},
	{
		id: "Clinical Equipment - Scopes",
		major: "Clinical Equipment",
		minor: "Scopes",
		category: "CLINEQ-SCOPES",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 5,
		prorate: "FSTMONTH",
	},
	{
		id: "Buildings - Site Infrastructure",
		major: "Buildings",
		minor: "Site Infrastructure",
		category: "BLDG-INFRASTRUC",
		assetAccount: 9132,
		wipAccount: 9332,
		expenseAccount: 5932,
		depreciation: "STL",
		lifeYears: 25,
		prorate: "FSTMONTH",
	},
	{
		id: "Intangible Assets - Software Inhouse Developed",
		major: "Intangible Assets",
		minor: "Software Inhouse Developed",
		category: "INTANG-SOFTWDEV",
		assetAccount: 9182,
		wipAccount: 9382,
		expenseAccount: 5982,
		depreciation: "STL",
		lifeYears: 5,
		prorate: "FSTMONTH",
	},
	{
		id: "Intangible Assets - Software Purchased",
		major: "Intangible Assets",
		minor: "Software Purchased",
		category: "INTANG-SOFTWPURCH",
		assetAccount: 9182,
		wipAccount: 9382,
		expenseAccount: 5982,
		depreciation: "STL",
		lifeYears: 5,
		prorate: "FSTMONTH",
	},
	{
		id: "Clinical Equipment - Sterilisers and Sanitisers",
		major: "Clinical Equipment",
		minor: "Sterilisers and Sanitisers",
		category: "CLINEQ-STERILE",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 12,
		prorate: "FSTMONTH",
	},
	{
		id: "Clinical Equipment - Surgical Instruments & Equipment",
		major: "Clinical Equipment",
		minor: "Surgical Instruments & Equipment",
		category: "CLINEQ-SURGEQUIP",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 7,
		prorate: "FSTMONTH",
	},
	{
		id: "ITC Equipment - Telecommunication Equipment",
		major: "ITC Equipment",
		minor: "Telecommunication Equipment",
		category: "ITCEQ-TELECOMEQ",
		assetAccount: 9179,
		wipAccount: 9379,
		expenseAccount: 5979,
		depreciation: "STL",
		lifeYears: 5,
		prorate: "FSTMONTH",
	},
	{
		id: "Clinical Equipment - Treatment and Operating Tables",
		major: "Clinical Equipment",
		minor: "Treatment and Operating Tables",
		category: "CLINEQ-TABLES",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 15,
		prorate: "FSTMONTH",
	},
	{
		id: "Motor Vehicles - Truck and Vans",
		major: "Motor Vehicles",
		minor: "Truck and Vans",
		category: "MOTOR-TRUCKS",
		assetAccount: 9139,
		wipAccount: 9339,
		expenseAccount: 5939,
		depreciation: "STL",
		lifeYears: 10,
		prorate: "FSTMONTH",
	},
	{
		id: "Clinical Equipment - Ventillator",
		major: "Clinical Equipment",
		minor: "Ventillator",
		category: "CLINEQ-VENTILATOR",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 10,
		prorate: "FSTMONTH",
	},
	{
		id: "Clinical Equipment - Warmer or warming Equipment",
		major: "Clinical Equipment",
		minor: "Warmer or warming Equipment",
		category: "CLINEQ-WARMERS",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 10,
		prorate: "FSTMONTH",
	},
	{
		id: "Clinical Equipment - Xray and Imaging Equipment incl MRI and CT",
		major: "Clinical Equipment",
		minor: "Xray and Imaging Equipment incl MRI and CT",
		category: "CLINEQ-IMAGING",
		assetAccount: 9162,
		wipAccount: 9362,
		expenseAccount: 5962,
		depreciation: "STL",
		lifeYears: 8,
		prorate: "FSTMONTH",
	},
];

const initialState = {
	data,
};

const assetCategorySlice = createSlice({
	name: "assetCategory",
	initialState,
});

export const { rcsReceived } = assetCategorySlice.actions;
export const selectMajorAssetCategory = createSelector(
	[(state) => state.capex.assetCategory.data],
	(data) => [
		...new Set(
			data
				.map((c) => c.major)
				.sort((a, b) => (a > b ? 1 : a === b ? 0 : -1))
		),
	]
);

export const selectMinorAssetCategory = createSelector(
	[(state) => state.capex.assetCategory.data],
	(data) => [
		...new Set(
			data
				.map((c) => c.minor)
				.sort((a, b) => (a > b ? 1 : a === b ? 0 : -1))
		),
	]
);

export const selectAssetCategory = (state) => state.capex.assetCategory.data;

export default assetCategorySlice.reducer;
